// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_UPDATE_DATOS_FINANCIEROS_STATE,
  SIMULADOR_FINANCIERO_ADD_AUTO
} from './constants';

export function updateDatosFinancierosState(datosFinancieros) {
  return {
    type: SIMULADOR_FINANCIERO_UPDATE_DATOS_FINANCIEROS_STATE,
    datosFinancieros: datosFinancieros
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_ADD_AUTO:

      if (state.editLinea) {
        return {
          ...state,
          editLineaData: {
            ...state.editLineaData,
            asignacionLineas: { ...state.editLineaData.asignacionLineas, tipoVehiculo: action.data.tipoVehiculo }
          },
        };
      } else { 
        return {
          ...state,
          altaNuevaLinea: {
            ...state.altaNuevaLinea,
            asignacionLineas: { ...state.altaNuevaLinea.asignacionLineas, tipoVehiculo: action.data.tipoVehiculo }
          },
        };
      }

    case SIMULADOR_FINANCIERO_UPDATE_DATOS_FINANCIEROS_STATE:
      if (state.editLinea) {
        let asignacionLineas = state.editLineaData.asignacionLineas;
        let id = state.editLineaData.id;
        return {
          ...state,
          editLineaData: {
            id: id,
            datosFinancieros: action.datosFinancieros,
            asignacionLineas: asignacionLineas
          }
        };
      } else {
        let asignacionLineas = state.altaNuevaLinea.asignacionLineas;
        return {
          ...state,
          altaNuevaLinea: {
            id: null,
            datosFinancieros: action.datosFinancieros,
            asignacionLineas: asignacionLineas
          }
        };
      }

    default:
      return state;
  }
}
